import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { Controller, useForm } from "react-hook-form";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { Select } from "antd";

const AdminAddEditStudentToCourse = () => {
  const { courseID, studentID } = useParams();
  const navigate = useNavigate();

  function reducer(state, action) {
    switch (action.type) {
      case "setErrors": {
        return {
          ...state,
          errors: action.payload,
        };
      }

      case "setSubmitAddStudent": {
        return {
          ...state,
          submitAddStudent: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitAddStudent: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  // !--------- Get  course -------
  const [
    allCoursesDetailsData,
    allCoursesDetailsErrors,
    allCoursesDetailsloading,
  ] = useAxios(
    `${process.env.REACT_APP_ADMIN_GET_ALL_COURSES_API}/${courseID}`,
    "GET",
    courseID,
    courseID
  );

  //!--------- Info  student -------
  const [studentInfoData, studentInfoErrors, studentInfoloading] = useAxios(
    `${process.env.REACT_APP_ADMIN_GET_STUDENT_COURSE_INFO_API}/${courseID}/${studentID}`,
    "GET",
    studentID,
    studentID
  );

  let api = studentID
    ? process.env.REACT_APP_ADMIN_EDIT_STUDENT_TO_COURSE_API
    : process.env.REACT_APP_ADMIN_ADD_STUDENT_TO_COURSE_API;

  //!--------- add  student -------
  const [AddEditStudentSuccess, AddEditStudentErrors, AddEditStudentLoading] =
    useAxios(
      api,
      "POST",
      state.submitAddStudent.flag,
      state.submitAddStudent.dependency,
      state.submitAddStudent.data,
      true
    );

  useEffect(() => {
    //!---add actions ----

    if (AddEditStudentSuccess) {
      navigate(-1);
      reset();
    }
    //! make the dependency false again to listen to the next try to submit
  }, [AddEditStudentSuccess]);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    setValue,
  } = useForm({ mode: "onTouched" });

  const onSubmit = (data) => {
    const allSessionKeys = allCoursesDetailsData?.data?.map((s) => s.key) || [];

    // Unchecked = all - selected
    const uncheckedLectureIds = allSessionKeys.filter(
      (id) => !data.lecture_ids.includes(id)
    );

    let finalData = studentID
      ? {
          username: data.username,
          lecture_ids: uncheckedLectureIds,
          course_id: courseID,
          student_id: studentID,
        }
      : {
          username: data.username,
          lecture_ids: uncheckedLectureIds,
          course_id: courseID,
        };

    dispatch({
      type: "setSubmitAddStudent",
      payload: {
        flag: "AddEditStudentToCourse",
        dependency: !state.submitAddStudent.dependency,
        data: finalData,
      },
    });
  };

  useEffect(() => {
    if (studentID) return;
    if (allCoursesDetailsData?.data?.length) {
      const allSessionKeys = allCoursesDetailsData.data.map(
        (session) => session.key
      );
      setValue("lecture_ids", allSessionKeys);
    }
  }, [allCoursesDetailsData, setValue, studentID]);

  useEffect(() => {
    if (!studentInfoData?.data || !allCoursesDetailsData?.data) return;

    if (studentID) {
      const allSessionKeys = allCoursesDetailsData.data.map(
        (session) => session.key
      );
      const uncheckedKeys = studentInfoData.data.lecture_ids;

      const checkedKeys = allSessionKeys.filter(
        (key) => !uncheckedKeys.includes(key)
      );

      setValue("lecture_ids", checkedKeys);
      setValue("username", studentInfoData.data.username);
    }
  }, [studentInfoData, allCoursesDetailsData, setValue, studentID]);

  return (
    <section className="flex h-auto w-full flex-col  items-center  dark:bg-dark dark:text-light">
      <HelmetTags
        title={`${studentID ? "Edit" : "Add"} Student | Nash Academy`}
      ></HelmetTags>

      <div className="form-container my-20 flex w-full flex-col items-center">
        <h2 className="my-20 text-center text-3xl font-semibold">
          Please fill in the information to {studentID ? "Edit" : "Add"} Student
        </h2>

        <form
          encType="multipart/form-data"
          method="post"
          onSubmit={handleSubmit(onSubmit)}
          className="md:max-w-3/4 flex  w-3/4  flex-col items-start justify-center gap-10 rounded-3xl bg-blue-200 p-16 shadow-lg shadow-blue-200/50"
        >
          {/** Name stage filed */}
          <div className="flex w-full items-start justify-between gap-16 flex-col md:gap-10 ">
            <div className="name flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="name">username</label>
              <input
                className="signin-inputs w-full pl-4"
                type="text"
                id="username"
                placeholder="username"
                name="username"
                disabled={studentID ? true : false}
                autoComplete="on"
                {...register("username", {
                  required: true,
                  maxLength: 40,
                  minLength: 3,
                })}
              />
              {errors.username && (
                <p className="w-full  text-[12px] text-blue-900  ">
                  {errors.username.type === "required" &&
                    "Please fill out this field"}
                  {errors.username.type === "maxLength" &&
                    "The maximum number of characters is 40 characters"}
                  {errors.username.type === "minLength" &&
                    "Please write at least 3 characters"}
                </p>
              )}
              {
                //!-------server errors -----

                AddEditStudentErrors &&
                  AddEditStudentErrors?.response?.data?.errors?.username && (
                    <p className="w-full  text-[12px] text-blue-900  ">
                      {
                        AddEditStudentErrors?.response?.data?.errors
                          ?.username[0]
                      }
                    </p>
                  )
              }
            </div>
            <div className="name flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="name">sessions</label>
              <Controller
                name="lecture_ids"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    {...field}
                    mode="multiple"
                    className="signin-inputs w-full !h-auto pl-4"
                    onChange={(value) => field.onChange(value)}
                    value={field.value}
                    loading={allCoursesDetailsloading}
                  >
                    {allCoursesDetailsData?.data?.map((session) => (
                      <Select.Option key={session.key} value={session.key}>
                        {session.title}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              />
              {AddEditStudentErrors?.response?.data?.errors?.lecture_ids && (
                <p className="w-full text-[12px] text-blue-900">
                  {AddEditStudentErrors.response.data.errors.lecture_ids[0]}
                </p>
              )}
              {AddEditStudentErrors &&
                !AddEditStudentErrors?.response?.data?.errors && (
                  <p className="text-red-500 text-sm">
                    Something went wrong. Please try again later.
                  </p>
                )}
            </div>
          </div>

          {/** submit */}
          <button
            disabled={
              !isValid || (AddEditStudentLoading && state.submitAddStudent.flag)
            }
            className=" submit mt-6 w-full "
            type="submit"
          >
            {AddEditStudentLoading && state.submitAddStudent.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <p>{studentID ? "Edit" : "Add"} Student</p>
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default AdminAddEditStudentToCourse;
